export const getOfs = state => {
    return state.ofs.listeOf;
}

export const getOfsToFactLabo = state => {
    return state.ofs.ofsToFactLabo;
}

// Tri inchangé, mais on utilise maintenant getOfsToFactLabo
export const getOfsToFact = state => {
    return getOfsToFactLabo(state)
        .filter(ofs => ofs.statut === 575)
        .sort((a, b) =>
            a.id_bijouterie - b.id_bijouterie ||
            a.typ_transp - b.typ_transp ||
            b.echeance - a.echeance ||
            a.labo - b.labo ||
            b.prix_fact - a.prix_fact
        );
}

// Regroupement par bijouterie → transport → labo
export const getOfsGroupByClientAndTransport = state => {
    return getOfsToFact(state).reduce((groupedData, ofs) => {
        const bijouterieId = ofs.id_bijouterie;
        const transportKey = ofs.descTypeTransp + ' ' + ofs.nom_ligne;
        const laboKey = ofs.labo === 1 ? 1 : 0;

        if (!groupedData[bijouterieId]) {
            groupedData[bijouterieId] = {};
        }

        if (!groupedData[bijouterieId][transportKey]) {
            groupedData[bijouterieId][transportKey] = { 0: [], 1: [] };
        }

        groupedData[bijouterieId][transportKey][laboKey].push(ofs);

        return groupedData;
    }, {});
};
